module.exports = __webpack_public_path__ + "static/img/honour2.72227c47.png";